const NotifiIconLight = ({ height, width }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M367.046 246.967C359.069 249.238 350.646 250.455 341.94 250.455C291.411 250.455 250.449 209.493 250.449 158.964C250.449 149.947 251.753 141.235 254.183 133.006H159.383C144.812 133.006 133 144.818 133 159.389V340.669C133 355.24 144.812 367.052 159.383 367.052H340.663C355.234 367.052 367.046 355.24 367.046 340.669V246.967Z"
        fill="#F5F6FB"
      />
      <path
        d="M419.056 146.013C419.056 181.919 389.949 211.026 354.043 211.026C318.138 211.026 289.03 181.919 289.03 146.013C289.03 110.107 318.138 81 354.043 81C389.949 81 419.056 110.107 419.056 146.013Z"
        fill="url(#paint0_linear_2143_21891)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2143_21891"
          x1="393.304"
          y1="91.1319"
          x2="330.824"
          y2="211.026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE7970" />
          <stop offset="1" stopColor="#FEB776" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default NotifiIconLight
